import PubSub from "pubsub-js";

const publish = (event, data) => PubSub.publish(event, data);
const subscribe = (event, callback) => PubSub.subscribe(event, callback);

export { publish, subscribe };
